var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.account.id)?_c('div',{class:_vm.classes,attrs:{"id":"app"}},[_c('div',{attrs:{"id":"app-content"}},[_c('drawer-menu'),_c('div',[_c('app-navbar',{attrs:{"sticky":_vm.sticky}}),_c('router-view')],1)],1),_c('app-footer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }